import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from './config';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { ForlagshusetScene } from './scenes/ForlagshusetScene';
import { HUDScene } from './scenes/HUDScene';
import { initStoreAsync } from './state/store';
import { registrerServiceWorker } from './pwa/registrerSw';
import { startInstallasjonsLytter } from './pwa/installasjon';
import { startNettstatusLytter } from './pwa/nettstatus';
import { audioManager } from './systems/audioManager';

const parent = document.getElementById('sp-canvas-host');
if (!parent) {
  throw new Error('Mangler #sp-canvas-host i index.html');
}

async function start(): Promise<void> {
  await initStoreAsync();

  new Phaser.Game({
    type: Phaser.AUTO,
    parent: parent!,
    transparent: true,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    render: {
      pixelArt: false,
      antialias: true,
    },
    scene: [BootScene, PreloadScene, ForlagshusetScene, HUDScene],
  });

  registrerServiceWorker();
  startInstallasjonsLytter();
  startNettstatusLytter();
  audioManager.start();
}

void start();
